/**
 * mayco-nav-hover.js
 * Přidává hover-open chování pro header navigaci na desktopu (≥990 px).
 * Na mobilu zůstává click (touch) bez změny.
 */

(function () {
  const DESKTOP_MIN_WIDTH = 990;
  const CLOSE_DELAY_MS = 180;

  function initHoverNav() {
    document.querySelectorAll('header-menu').forEach((menuEl) => {
      const details = menuEl.querySelector('details');
      if (!details) return;

      let closeTimer = null;

      const isDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;

      const openMenu = () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        if (!details.open) {
          details.setAttribute('open', '');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        }
      };

      const scheduleClose = () => {
        if (!isDesktop()) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY_MS);
      };

      menuEl.addEventListener('mouseenter', openMenu);
      menuEl.addEventListener('mouseleave', scheduleClose);

      // Kliknutí přímo na summary (oblast šipky) na desktopu:
      // pokud je menu otevřené hoverem, zabránit zavření kliknutím
      details.querySelector('summary')?.addEventListener('click', (e) => {
        if (!isDesktop()) return;
        if (details.open) e.preventDefault();
      });
    });
  }

  // Globální split-button handler: text v <summary> naviguje, šipka toggleuje.
  // Pokrývá desktop mega menu i mobilní drawer.
  function initSplitNav() {
    document.querySelectorAll('summary .mc-nav__text-link').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.stopPropagation(); // zabránit toggle <details>, <a> href se sleduje přirozeně
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHoverNav();
      initSplitNav();
    });
  } else {
    initHoverNav();
    initSplitNav();
  }
})();
